import assert from 'http-assert-plus';
import ms from 'ms';

export function distanceBrokenTimer(timeThen, timeNow) {
  const then = timeThen instanceof Date ? timeThen.getTime() : timeThen;
  const now = timeNow instanceof Date ? timeNow.getTime() : timeNow;
  assert(typeof then === 'number', 'Expected first argument to be a Date or number');
  assert(typeof now === 'number', 'Expected first argument to be a Date or number');

  const divmod = (total, unit) => {
    const mod = total % unit;
    const div = (total - mod) / unit;
    return [ div, mod ];
  };
  const format = (value, prefixZero = false, suffix = '') => {
    if (value > 0) {
      return `${prefixZero && value < 10 ? '0' : ''}${value}${suffix}`;
    } else {
      return `00${suffix}`;
    }
  };

  const diff = Math.abs(then - now);
  const [ weeks, dweeks ] = divmod(diff, 7 * 24 * 60 * 60 * 1000);
  const [ days, ddays ] = divmod(dweeks, 24 * 60 * 60 * 1000);
  const [ hours, dhours ] = divmod(ddays, 60 * 60 * 1000);
  const [ minutes, dminutes ] = divmod(dhours, 60 * 1000);
  const [ seconds ] = divmod(dminutes, 1000);

  return (a => a.filter(b => typeof b === 'string' && b.length).join(' '))([
    weeks > 0 ? format(weeks, false, 'w') : null,
    days > 0 ? format(days, false, 'd') : null,
    hours > 0 ? format(hours, false, 'h') : null,
    format(minutes || 0, true, 'm'),
    format(seconds, true, 's'),
  ]);
}

export default {
  data: () => ({
    timeNow: new Date(),
  }),
  mounted() {
    this.timeNow = new Date();
    this._timeNowInterval = setInterval(() => this.timeNow = new Date(), ms('1s'));
  },
  beforeDestroy() {
    this._timeNowInterval && clearInterval(this._timeNowInterval);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/timeNow.js